module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "eccodarwin-co2flux-monthgrid-v5.thumbnail.co2.5b5d64eb.png";